import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import BackedByPanel from '@/website/components/switchWithJove/home/backedByPanel';
import CalculatePriceView from '@/website/components/switchWithJove/home/calculate-price';
import CustomerTestimonial from '@/website/components/switchWithJove/home/customerTestimonial';
import HowToSwitch from '@/website/components/switchWithJove/home/howToSwitch';
import HowWeGetBestPrice from '@/website/components/switchWithJove/home/howWeGetBestPrice';
import WhySmartChoice from '@/website/components/switchWithJove/home/whySmartChoice';
import { getRequestLanguage } from '@/website/constants/locales';
import PageLayout from '@/website/layouts/page/index';
import { ContentfulPageProps, getContentfulData } from '@/website/lib/getContentfulData';
import { getSwitchToJoveWebsiteCrawlerHeadData } from '@/website/util/crawler';

const SLUG = 'switch-to-jove';
export async function getServerSideProps(context: GetServerSidePropsContext): Promise<GetServerSidePropsResult<ContentfulPageProps>> {
  const language = getRequestLanguage(context.locale, context.req.headers.cookie);

  return getContentfulData(context, SLUG, {
    metaInfo: {
      title: getSwitchToJoveWebsiteCrawlerHeadData(language)?.title,
      description: getSwitchToJoveWebsiteCrawlerHeadData(language)?.description,
      images: '/switch-to-jove-landing.png',
    },
    useNewLogic: true,
    dataFileName: 'switch-to-jove-data.json',
    activeLanguage: language,
  });
}
const SwitchToJoveHomePage: NextPage = (props: ContentfulPageProps) => {
  const { post } = props;

  return (
    <PageLayout.Wrapper>
      <PageLayout.Header></PageLayout.Header>
      <PageLayout.Content className="items-center">
        {!!post && (
          <>
            <CalculatePriceView post={post} />
            <BackedByPanel post={post} />
            <HowToSwitch post={post} />
            <WhySmartChoice post={post} />
            <HowWeGetBestPrice post={post} />
            <CustomerTestimonial post={post} />
          </>
        )}
      </PageLayout.Content>
      <PageLayout.Footer></PageLayout.Footer>
    </PageLayout.Wrapper>
  );
};

export default SwitchToJoveHomePage;
